// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type BookingInformationContextProperties = {
  is_live_journey?: boolean;
  mins_to_departure?: number;
  is_in_wallet?: boolean;
  notifications_allowed?: boolean;
  geo_location_allowed?: boolean;
  provider_code?: string;
  ticket_type?: string;
  geo_location_on?: boolean;
  booking_id: string;
  transport_type?: string;
  journey_phase?: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/booking_information_context/jsonschema/2-0-0';
export const bookingInformationContextName = 'booking_information_context';
export class BookingInformationContext extends BaseTrackingContext<BookingInformationContextProperties> {
  constructor(properties: BookingInformationContextProperties) {
    super(bookingInformationContextName, schema, properties);
  }
}
